// config.js
const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
  apiUrl: isDevelopment ? 'http://localhost:5000' : 'https://api.mashfarm.online',
  isDev:isDevelopment,

};

export default config;
